// 3rd-party libraries
import $ from 'jquery';
import 'bootstrap';
import 'responsive-slides/responsiveslides.js';
import 'rwdImageMaps/jquery.rwdImageMaps.js';
import 'bxslider/jquery.bxslider.js';

// Environment
import ENV from 'environment';

// Components
import './Components/navigation';

// Document Ready
$(document).ready(function () {
    // Set special class to all bullet-list headings
    $('#content-main').find('ol').prev('h3').addClass('ol-heading');

    // rowNoPadding
    $('.rowNoPadding').parent('.container').css('padding', '0px');

    // sidebar_spotlight
    $('.sidebarSpotlight_Container').first().addClass('firstElement');
    $('.sidebarSpotlight_Container').last().addClass('lastElement');

    // subcategoryBox
    $('.subcategoryBox_Text').find('.models').find('li').each(function (index) {
        var this_html = $(this).find('a').html();
        $(this).find('a').html('<button class="btn btn-default has-arrow-right" >' + this_html + '</button>');
    });

    // ICON MATRIX
    $('.lemken-icon-matrix .lemken-icon-matrix-img').click(function () {
        var link = $(this).siblings('.lemken-icon-matrix-link').find('a');
        link[0].click();
    });

    // BANNER
    $('.categoryBanner').responsiveSlides({
        auto: true,
        maxwidth: 4000,
        timeout: 10000,
        speed: 1400,
        pager: true
    });

    // Intro Slider
    $('.introSlider').responsiveSlides({
        auto: true,
        maxwidth: 4000,
        timeout: 10000,
        speed: 1400,
        pager: true
    });

    // YouTube Intros
    var onPlay = function (event) {
        var player = this;
        player.p.mute();
    };
    var onEnd = function (event) {
        var player = this;
        player.p.playVideo();
    };
    $('.rslides li div[data-youtube]').each(function () {
        $(this).player({
            video: $(this).attr('data-youtube'),
            width: 1920,
            height: 1080,
            playerVars: {
                autoload: false, // load the player automatically?
                autoplay: true,
                start: 1, // start video at offset
                order: 'relevance', // 'published', 'rating', 'viewCount'
                author: false,
                hide: 1, // 0 = always visible, 1 = hide progress bar and controls, 2 = hide progress bar
                controls: 0,
                showinfo: 0,
                modestbranding: 1,
                wmode: 'transparent',
                version: 0,
                format: 0,
                limit: 0,
                key: false,
                render: false,
                truncate: false,
                click: false // plugin callback
            },
            events: {
                play: onPlay,
                end: onEnd,
            }
        });
    });

    // contentSlider
    $('.contentSlider').bxSlider({
        mode: 'horizontal',
        captions: false,
        nextText: '>',
        prevText: '<',
        pager: false
    });

    // bannerVideo
    $('.bannerVideo').bxSlider({
        mode: 'horizontal',
        captions: false,
        nextText: '>',
        prevText: '<',
        pager: false
    });

    // lemken_events
    if ($('.tx-lemken-events ul.filter input:checked').length > 0) {
        $('.tx-lemken-events ul.filter input:checked').closest('li').addClass('active');
    } else {
        $('.tx-lemken-events ul.filter li:has(a)').addClass('active');
    }
    $('.tx-lemken-events ul.filter li:not(.active):has(label)').click(function () {
        // make sure the correct radio button is checked
        $(this).find('input').attr('checked', true);
        $(this).closest('form').submit();
    });

    // lemken_dealerlocator
    var geolocate = function () {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                $('.tx-lemken-dealerlocator input#latitude').val(position.coords.latitude);
                $('.tx-lemken-dealerlocator input#longitude').val(position.coords.longitude);
                $('.tx-lemken-dealerlocator form').submit();
            });
        }
    }
    $('.tx-lemken-dealerlocator .locate').click(geolocate);

    // row-grey
    // TODO nicht mit CSS zu loesen?
    var $containerGrey = $('.row-grey').parent('.container');
    $containerGrey.addClass('container-grey');


    var window_device = check_window_device(); // Returns the Device as string

    // bannerThumbnail
    if (window_device == 'desktop') {
        var slides = 6;
        var slidesVideo = 2;
    } else if (window_device == 'tablet') {
        var slides = 4;
        var slidesVideo = 2;
    } else {
        var slides = 2;
        var slidesVideo = 1;
    }
    $('.bannerThumbnail').bxSlider({
        mode: 'horizontal',
        captions: false,
        nextText: '>',
        prevText: '<',
        pager: false,
        minSlides: slides,
        maxSlides: slides,
        slideWidth: 500,
        slideMargin: 0
    });

    // bannerThumbnailEinzeilig
    $('.bannerThumbnailEinzeilig').bxSlider({
        mode: 'horizontal',
        captions: false,
        nextText: '>',
        prevText: '<',
        pager: false,
        minSlides: slides,
        maxSlides: slides,
        slideWidth: 500,
        slideMargin: 0
    });

    // galleryVideo
    videoGalleryFixAmount(slidesVideo);

    /*
    var galleryVideo = $('.galleryVideo').bxSlider({
        mode: 'horizontal',
        captions: false,
        nextText: '>',
        prevText: '<',
        pager: false,
        minSlides: slidesVideo,
        maxSlides: slidesVideo,
        slideWidth: 2000,
        slideMargin: 0
    });*/

    var Gallerysliders = new Array();
    $('.galleryVideo').each(function (i, slider) {
        Gallerysliders[i] = $(this).bxSlider({
            mode: 'horizontal',
            captions: false,
            nextText: '>',
            prevText: '<',
            pager: false,
            minSlides: slidesVideo,
            maxSlides: slidesVideo,
            slideWidth: 2000,
            slideMargin: 0
        });
    });

    // Padding for GalleryVideo
    if (window_device != 'smartphone') {
        $('.galleryVideo').each(function (index_galleryVideo) {

            $(this).find('li').each(function (index) {
                if (((index / 2) - Math.floor(index / 2)) === 0) {
                    $(this).css('padding-right', '10px');
                } else {
                    $(this).css('padding-left', '10px');
                }
            });

        });
    }

    // Rezise !!
    var window_device_old = window_device;
    $(window).resize(function () {

        window_device = check_window_device();

        if (window_device == 'desktop') {
            slides = 6;
            slidesVideo = 2;
        } else if (window_device == 'tablet') {
            slides = 4;
            slidesVideo = 2;
        } else {
            slides = 2;
            slidesVideo = 1;
        }

        // If the Device changes
        if (window_device_old != window_device) {

            if ($('.bannerThumbnail').length > 0) {
                $('.bannerThumbnail').reloadSlider({
                    mode: 'horizontal',
                    captions: false,
                    nextText: '>',
                    prevText: '<',
                    pager: false,
                    minSlides: slides,
                    maxSlides: slides,
                    slideWidth: 500,
                    slideMargin: 0
                });
            }

            if ($('.bannerThumbnailEinzeilig').length > 0) {
                $('.bannerThumbnailEinzeilig').reloadSlider({
                    mode: 'horizontal',
                    captions: false,
                    nextText: '>',
                    prevText: '<',
                    pager: false,
                    minSlides: slides,
                    maxSlides: slides,
                    slideWidth: 500,
                    slideMargin: 0
                });
            }

            videoGalleryFixAmount(slidesVideo);

            $.each(Gallerysliders, function (i, slider) {
                slider.reloadSlider({
                    mode: 'horizontal',
                    captions: false,
                    nextText: '>',
                    prevText: '<',
                    pager: false,
                    minSlides: slidesVideo,
                    maxSlides: slidesVideo,
                    slideWidth: 2000,
                    slideMargin: 0
                });
            });

            // Padding for GalleryVideo
            if (window_device != 'smartphone') {
                $('.galleryVideo').each(function (index_galleryVideo) {

                    $(this).find('li').each(function (index) {
                        if (((index / 2) - Math.floor(index / 2)) === 0) {
                            $(this).css('padding-right', '10px');
                        } else {
                            $(this).css('padding-left', '10px');
                        }
                    });

                });
            } else {
                $('.galleryVideo').find('li').css('padding', '0');
            }

            organizeGallery($('.gallery'));

            window_device_old = window_device;
        }

    });


    // image caption and responsive images
    $('figcaption').click(function () {
        $(this).closest('figure').children('a').click();
    });
    // TODO per TypoScript loesen
    $('.ce-image img').addClass('img-responsive');


    // recommend box
    $('.dropdown.mail .dropdown-menu .url').attr('height', $('.dropdown.mail .dropdown-menu .url').innerHeight());
    $('.dropdown.mail').on('shown.bs.dropdown', function () {
        $(this).find('.dropdown-menu .url').select();
    });

    function videoGalleryFixAmount(slidesVideo) {
        var counter = 0;
        var counter_no_clone = 0;
        var length = 0;

        $('.galleryVideo').each(function (index_galleryVideo) {
            counter = 0;

            counter_no_clone = 0;
            length = $(this).find('li').length;

            var needed_li_elements = Math.ceil(length / slidesVideo) * slidesVideo;

            $(this).find('li').each(function (index) {


                counter = counter + 1;

                if (length == counter) {

                    if (needed_li_elements > counter) {

                        // Elemente erstellen
                        var amountSlidesToAdd = needed_li_elements - counter;

                        for (var i = 0; i < amountSlidesToAdd; i++) {

                            // more statements
                            $(this).parent('.galleryVideo').append("" +
                                "<li><div class='galleryVideo_innerContainer_box' ><div class='galleryVideo_innerContainer' >" +
                                "<a class='galleryVideo_link' href='' data-lity>" +
                                "<img src='/typo3conf/ext/lem_site/Resources/Public/Images/transparent.png' alt='placeholder' class='img-responsive' />" +
                                "<div class='galleryVideo_playButtonBox' ><div class='galleryVideo_playButton' ></div>" +
                                "</div></a><div class='clearfix' ></div></div></div></li>");
                        }

                    }
                }
            });

        });
    }


    // organize gallery
    var organizeGallery = function (gallery) {
        var rows = $(gallery).attr('data-rows') || 2;
        var imagesPerPage = 6 * rows;
        if (check_window_device() == 'tablet') {
            imagesPerPage = 4 * rows;
        } else if (check_window_device() == 'smartphone') {
            imagesPerPage = 2 * rows;
        }

        // clone all images
        var images = $(gallery).find('.image').clone();

        // delete all images from DOM
        $(gallery).find('.item .row').remove();

        // clone one empty item
        var item = $(gallery).find('.item.active').clone();

        // delete all items from DOM
        $(gallery).find('.item').remove();

        // recreate all pages
        var pages = Math.ceil(images.length / imagesPerPage);
        for (var i = 0; i < pages; i++) {
            item.append($('<div class="row"></div>').append(images.slice(i * imagesPerPage, i * imagesPerPage + imagesPerPage)));
            $(gallery).find('.carousel-inner').append(item.clone());
            item.find('.row').remove();
            if (i == 0) {
                item.removeClass('active');
            }
        }
        if (pages == 1) {
            $(gallery).removeClass('carousel');
        } else {
            $(gallery).addClass('carousel');
        }
    }
    $('.gallery').each(function () {
        organizeGallery(this);
    });


    // Responsive Image Maps
    $('img[usemap]').rwdImageMaps();


    // show distributors on klick
    $('*[data-zone]').click(function (event) {
        var element = $(this);
        $.get(element.attr('data-zone'), null, function (data) {
            $('#distributors').html(data);
            $('#distributors img').load(function () {
                if ($('#distributors').height() > $('#distributors').parent().height()) {
                    $('#distributors').parent().css('height', $('#distributors').css('height'));
                }
            });
            $('#distributors').show();
            // focus box
            //window.location = element.attr('href');
        });
    });
    // close distributor lightbox
    $('#distributors').on('click', 'button.close', function () {
        $('#distributors').hide();
        $('#distributors').parent().css('height', '100%');
    });


    // Top Share Button
    $('#p95').append($('#metaTop .dropdown-menu'));
    $('#p95 > a').attr('href', '#').attr('data-toggle', 'dropdown').attr('role', 'button').attr('id', 'meta-top-share');


    // Add active state to accordion panels
    $('.panel-group .panel .panel-collapse').on('show.bs.collapse', function () {
        $(this).parent('.panel').addClass('active');
    });
    $('.panel-group .panel .panel-collapse').on('hide.bs.collapse', function () {
        $(this).parent('.panel').removeClass('active');
    });


    // Sync accordions on product pages (technical_data and standard_equipment)
    $('.tx-lemken-catalog #technical_data .panel-heading a, .tx-lemken-catalog #standard_equipement .panel-heading a').click(function () {
        // toggle clicked panels
        var index = $(this).closest('.panel').prevAll().length + 1;
        $('.tx-lemken-catalog #technical_data .panel:nth-child(' + index + ') .panel-collapse').collapse('toggle');
        $('.tx-lemken-catalog #standard_equipement .panel:nth-child(' + index + ') .panel-collapse').collapse('toggle');

        // hide panel siblings
        $('.tx-lemken-catalog #technical_data .panel:nth-child(' + index + ')').siblings().children('.panel-collapse').collapse('hide');
        $('.tx-lemken-catalog #standard_equipement .panel:nth-child(' + index + ')').siblings().children('.panel-collapse').collapse('hide');
    });


    // hide responsive notification on product tables
    $('#technical_data .panel-collapse').on('shown.bs.collapse', function () {
        var tableResponsive = $(this).find('.table-responsive');
        if (tableResponsive.width() < tableResponsive.children('table').width()) {
            tableResponsive.addClass('show-scroll-icon');
            tableResponsive.scroll(function () {
                tableResponsive.removeClass('show-scroll-icon');
                tableResponsive.off('scroll');
            });
        }
    });
    $('.table-responsive').scroll(function () {
        $(this).addClass('show-scroll-icon');
        $(this).off('scroll');
    });


    // initialize ekko lightbox
    $('*[data-toggle="lightbox"]').each(function () {
        if (!$(this).attr('data-footer')) {
            if ($(this).siblings('figcaption').length > 0 && $(this).siblings('figcaption').html()) {
                $(this).attr('data-footer', $(this).siblings('figcaption').html());
            }
        }
    });
    $(document).delegate('*[data-toggle="lightbox"]', 'click', function (event) {
        event.preventDefault();
        if (check_window_device() != 'smartphone') {
            $(this).ekkoLightbox({
                left_arrow_class: '.left .fa .fa-angle-left',
                right_arrow_class: '.right .fa .fa-angle-right',
            });
        }
    });


    // grey backround section heading class ( greyHeading )
    $('.row-grey').parent('.container').find('h2.csc-firstHeader:first-child').addClass('greyHeading');

    // Banner Detail
    var bannerNormalWidth = 580;
    window_device = check_window_device();
    if (window_device == 'desktop') {
        var containerWidth = $('#footerNav').find('.container').width();
        var windowWidth = $(window).width();
        var containerMargin = (windowWidth - containerWidth) / 2;
        var newBannerWidth = bannerNormalWidth + containerMargin;
        var newPlateWidth = bannerNormalWidth - 40;
        $('.categoryBanner_container.detail').find('.plate_container').css('padding-left', '' + containerMargin + 'px');
        $('.categoryBanner_container.detail').find('.plate_container').css('max-width', '' + newBannerWidth + 'px');
        $('.categoryBanner_container.detail').find('.plate_container').css('min-width', '' + newBannerWidth + 'px');
        $('.categoryBanner_container.detail').find('.plate_container').css('width', '' + newBannerWidth + 'px');
        $('.categoryBanner_container.detail').find('.plate_container').find('.plate').css('width', '' + newPlateWidth + 'px');
    }

    $(window).resize(function () {

        window_device = check_window_device();

        if (window.innerWidth > 1300) {
            var containerWidth = $('#footerNav').find('.container').width();
            var windowWidth = $(window).width();
            var containerMargin = (windowWidth - containerWidth) / 2;
            var newBannerWidth = bannerNormalWidth + containerMargin;
            var newPlateWidth = bannerNormalWidth - 40;
            $('.categoryBanner_container.detail').find('.plate_container').css('padding-left', '' + containerMargin + 'px');
            $('.categoryBanner_container.detail').find('.plate_container').css('max-width', '' + newBannerWidth + 'px');
            $('.categoryBanner_container.detail').find('.plate_container').css('min-width', '' + newBannerWidth + 'px');
            $('.categoryBanner_container.detail').find('.plate_container').css('width', '' + newBannerWidth + 'px');
            $('.categoryBanner_container.detail').find('.plate_container').find('.plate').css('width', '' + newPlateWidth + 'px');
        }
        if (window.innerWidth <= 1300) {
            $('.categoryBanner_container.detail').find('.plate_container').css('padding-left', '');
            $('.categoryBanner_container.detail').find('.plate_container').css('max-width', '');
            $('.categoryBanner_container.detail').find('.plate_container').css('min-width', '');
            $('.categoryBanner_container.detail').find('.plate_container').css('width', '').find('.plate').css('width', '');
        }

    });


    $(document).on('click', '#sidebarDistributorPortal>ul>li>i', function () {
        var plus = $(this),
            list = plus.parent(),
            level2 = list.find('.level2');

        plus.toggleClass('minus');
        level2.slideToggle(100);
    });
});

function check_window_device() {

    var device = '';
    var width = window.innerWidth;

    if (width > ENV.displaySizes.tablet) {
        device = 'desktop';
    } else if (width < ENV.displaySizes.tablet && width > ENV.displaySizes.smartphone) {
        device = 'tablet';
    } else {
        device = 'smartphone';
    }

    return device;
}

// share with social media
function share(service, url) {
    var url = url || window.location.href;
    var shareUrl = '';
    switch (service) {
        case 'facebook':
            shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
            break;

        case 'twitter':
            shareUrl = 'https://twitter.com/home?status=' + url;
    }
    window.open(shareUrl);
}
